import { report } from './observability';

/**
 * Shared by every `client_error` call site (error boundaries' `onError`,
 * the router's `RouteError`, future `window.onerror`/`unhandledrejection`
 * listeners) so the "how do I turn a caught error into an event" logic
 * exists once. `componentStack`, when available, is usually more
 * diagnostic than the JS stack for a render-phase crash -- prefer it when
 * both are present.
 */
export function reportClientError(params: {
	source: string;
	category?: string;
	error: unknown;
	componentStack?: string;
}): void {
	const { source, category, error, componentStack } = params;
	const message = error instanceof Error ? error.message : String(error);
	const stack =
		componentStack ?? (error instanceof Error ? error.stack : undefined);

	report({
		name: 'client_error',
		payload: { source, category, message, stack },
	});
}
